<script>
/* eslint-disable max-len */
import { VTimeline } from 'vuetify/lib';

export default {
  name: 'OrsTimeline',
  extends: VTimeline,
  computed: {
    classes() {
      return {
        'ors-tml': true,
        'v-timeline--align-top': this.alignTop,
        'v-timeline--dense': this.dense,
        'v-timeline--reverse': this.reverse,
        ...this.themeClasses,
      };
    },
  },
};
</script>

<style lang="css" scoped>
.ors-tml .ors-tml-i /deep/ .v-timeline-item__body  .v-timeline-item__divider {
  display: none;
}

.ors-tml:not(.v-timeline--dense):not(.v-timeline--reverse)  {
  display: grid;
  direction: rtl; /* reverse grid */
  grid-template-columns: 1fr 1fr;
}

.ors-tml:not(.v-timeline--dense):not(.v-timeline--reverse) > * {
  direction: ltr;
}

.ors-tml:not(.v-timeline--dense):not(.v-timeline--reverse)  .ors-tml-i {
  display: block;
}

.ors-tml:not(.v-timeline--dense):not(.v-timeline--reverse)  .ors-tml-i:not(:last-child) {
  padding-bottom: 0;
}

.ors-tml:not(.v-timeline--dense):not(.v-timeline--reverse)  .ors-tml-i /deep/ .v-timeline-item__divider {
  display: none;
}

.ors-tml.v-timeline:not(.v-timeline--dense):not(.v-timeline--reverse) .ors-tml-i /deep/ .v-timeline-item__body {
  height: auto;
  position: relative;
}

.ors-tml.v-timeline:not(.v-timeline--dense):not(.v-timeline--reverse) .ors-tml-i /deep/ .v-timeline-item__body .v-timeline-item__divider {
  position: absolute;
  top: calc(50% - 19px);
  width: 96px;
}

.ors-tml.v-timeline:not(.v-timeline--dense):not(.v-timeline--reverse) .ors-tml-i.v-timeline-item:nth-child(odd):not(.v-timeline-item--before) /deep/ .v-timeline-item__body,
.ors-tml.v-timeline:not(.v-timeline--dense):not(.v-timeline--reverse) .ors-tml-i.v-timeline-item--after /deep/ .v-timeline-item__body {
  max-width: 100%;
  margin-left: 48px;
}

.ors-tml.v-timeline:not(.v-timeline--dense):not(.v-timeline--reverse) .ors-tml-i.v-timeline-item:nth-child(odd):not(.v-timeline-item--before) /deep/ .v-timeline-item__body .v-timeline-item__divider,
.ors-tml.v-timeline:not(.v-timeline--dense):not(.v-timeline--reverse).ors-tml-i.v-timeline-item--after /deep/ .v-timeline-item__body .v-timeline-item__divider {
  display: flex;
  left: -96px;
}

.ors-tml.v-timeline:not(.v-timeline--dense):not(.v-timeline--reverse) .ors-tml-i:nth-child(even):not(.v-timeline-item--after) /deep/ .v-timeline-item__body,
.ors-tml.v-timeline:not(.v-timeline--dense):not(.v-timeline--reverse) .ors-tml-i.v-timeline-item--before /deep/  .v-timeline-item__body {
  margin-top: 96px;
  margin-right: 48px;
  max-width: calc(100%);
}

.ors-tml.v-timeline:not(.v-timeline--dense):not(.v-timeline--reverse) .ors-tml-i.v-timeline-item:nth-child(even):not(.v-timeline-item--after) /deep/ .v-timeline-item__body .v-timeline-item__divider,
.ors-tml.v-timeline:not(.v-timeline--dense):not(.v-timeline--reverse).ors-tml-i.v-timeline-item--before /deep/ .v-timeline-item__body .v-timeline-item__divider {
  display: flex;
  right: -96px;
}

</style>
